import { Link } from "react-router-dom";

const NotFoundPage = () => {
  return (
    <div className="card card--outlined" style={{ maxWidth: "520px" }}>
      <h3 className="card-title">Pagina nao encontrada</h3>
      <p className="card-subtitle">O endereco acessado nao existe.</p>
      <Link className="button button--primary" to="/dashboard">
        Voltar ao painel
      </Link>
    </div>
  );
};

export default NotFoundPage;
